<template>
  <li class="mega-menu__menu-item mega-menu__menu-item--depth-2">
    <a v-if="itemIsDefined(itemDepth1, 'link')"
      :href="getLink(itemDepth1)"
      class="mega-menu__link mega-menu__link--depth-2"
      >{{ itemDepth1.label }}</a>
    <h5 v-else-if="itemIsDefined(itemDepth1, 'label')" 
      class="mega-menu--depth-2__title">{{ itemDepth1.label }}</h5>
    <ul class="mega-menu--depth-3"
      :class="itemDepth1.childMenu.length > 5 ? 'mega-menu--depth-3--2-col' : ''"
      v-if="itemIsDefined(itemDepth1, 'childMenu')">
      <mega-menu-level-3
        v-for="(itemDepth2, index) in itemDepth1.childMenu"
        :key="`mega-menu-3-${index}`"
        :itemDepth2="itemDepth2"
      />
    </ul>
  </li>
</template>

<script>
import MegaMenuLevel3 from "@/components/layout/header/MegaMenu/MegaMenuLevel3";
import mainSite from "@/util/mainSite"

export default {
  name: "mega-menu-level-2",
  mixins: [mainSite],
  components: {
    MegaMenuLevel3,
  },
  props: {
    itemDepth1: {
      type: Object,
      required: true,
      default: {}
    },
  },
};
</script>